const stats = [
  { value: '8年+', label: '行业深耕经验' },
  { value: '2,800万+', label: '全球注册用户' },
  { value: '200+', label: '覆盖国家与地区' },
  { value: '99.9%', label: '平台稳定运行率' },
];

const partners = [
  '英超联赛官方数据合作',
  'NBA官方合作伙伴',
  '西甲联赛数据提供商',
  'ATP巡回赛合作平台',
  'LCK联赛数据分析支持',
];

export default function StatsSection() {
  return (
    <section className="py-12 md:py-16 bg-primary-600">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-10">
          {stats.map((stat, i) => (
            <div key={i} className="text-center">
              <p className="font-heading text-3xl md:text-4xl font-bold text-background-50">
                {stat.value}
              </p>
              <p className="mt-2 text-sm text-primary-200">{stat.label}</p>
            </div>
          ))}
        </div>
        <div className="pt-8 border-t border-primary-500/40">
          <p className="text-center text-sm text-primary-200 mb-4">权威合作机构</p>
          <div className="flex items-center justify-center gap-6 md:gap-10 flex-wrap">
            {partners.map((partner, i) => (
              <span key={i} className="text-sm text-primary-100 font-medium">
                {partner}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}